import { useEffect } from 'react';
import { blockDateRange, MetricError, useMetricsErrors } from 'venn-state';
import { useSelectedMetrics } from '../../../../studio-blocks/logic/useSelectedMetrics';
import { useRecoilValue } from 'recoil';

export const usePerformanceAndRiskMetricErrors = (id: string) => {
  const { clearMetricByKeys, appendMetricErrors } = useMetricsErrors(id);
  const metrics = useSelectedMetrics();
  const dateRange = useRecoilValue(blockDateRange(id));

  useEffect(() => {
    const vol60DayMetricKey = 'DAY_60-volatility';
    const has60DayVol = metrics.some((metric) => metric.key === vol60DayMetricKey);
    if (has60DayVol && dateRange?.frequency !== 'DAILY') {
      appendMetricErrors([
        {
          metricKey: vol60DayMetricKey,
          error: MetricError.VOL_60_DAY_NON_DAILY,
          type: 'error',
        },
      ]);
    }

    return () => clearMetricByKeys([vol60DayMetricKey]);
  }, [clearMetricByKeys, appendMetricErrors, metrics, dateRange]);
};
